import { CompletePageTemplate } from "../components/templates";

export const CompletePage = () => {
  return <CompletePageTemplate />;
};
